<div class="row detail-content__row">
  <div class="col-12 col-lg-2">
    <h5 class="detail-steps__title">Termini</h5>
  </div>
  <div class="col-12 col-lg-10">
    <div class="detail-info-box">
      <div class="detail-info-box__item" *ngFor="let accessory of accessories">
        <h5><i [ngClass]="accessory.icon"></i> {{accessory.name}}</h5>
      </div>
    </div>
  </div>
</div>
